var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeatherRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/Weather/Rain",
    transform: "translate(-3.000000, -4.000000)",
    fill: "#6379ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48941553,13.9929409 C5.3151903,13.6778331 5.80114588,13.3970209 5.97511068,13.7116131 L5.97511068,13.7116131 L6.72539901,15.0677113 C6.89962424,15.3825613 6.41366866,15.6633734 6.23970386,15.3487813 L6.23970386,15.3487813 Z M8.27675881,13.9929409 C8.10227315,13.6778331 8.58848916,13.3970209 8.76245396,13.7116131 L8.76245396,13.7116131 L9.51274229,15.0677113 C9.68696752,15.3825613 9.20101194,15.6633734 9.02678671,15.3487813 L9.02678671,15.3487813 Z M11.2062949,13.9929409 C11.0320696,13.6778331 11.5182857,13.3970209 11.6922505,13.7116131 L11.6922505,13.7116131 L12.4425388,15.0677113 C12.616764,15.3825613 12.130548,15.6633734 11.9565832,15.3487813 L11.9565832,15.3487813 Z M14.0376502,13.9929409 C13.863425,13.6778331 14.3493806,13.3970209 14.5236058,13.7116131 L14.5236058,13.7116131 L15.2738941,15.0677113 C15.4481193,15.3825613 14.9619033,15.6633734 14.7879385,15.3487813 L14.7879385,15.3487813 Z M9.58488039,4 C11.2391086,4 12.7678113,5.01159413 13.423044,6.52782494 C13.6279996,6.48373047 13.8376428,6.46129644 14.0475464,6.46129644 C15.6754716,6.46129644 17,7.78541978 17,9.41304714 C17,11.0406745 15.6754716,12.3650557 14.0475464,12.3650557 L14.0475464,12.3650557 L5.44800774,12.3650557 C4.09821794,12.3650557 3,11.2675934 3,9.91845741 C3,8.56932142 4.09821794,7.47160126 5.44800774,7.47160126 L5.44800774,7.47160126 L5.46233119,7.47160126 C5.80427099,5.45331239 7.5207411,4 9.58488039,4 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherRain);
export default __webpack_public_path__ + "static/media/weather-rain.6b5558b94f3edf84ad6ca4bbe223119b.svg";
export { ForwardRef as ReactComponent };